/* eslint-disable camelcase */
import {
  GQLLocalAccountCustomer,
  GQLLocalAccountConsents,
} from '~/graphql/__generated__/interfacesLocal'

export interface MarxyConfig {
  customer?: GQLLocalAccountCustomer
  consents?: GQLLocalAccountConsents
  marxy?: MarxyType
}

export interface Marxy {
  config: MarxyConfig
  cookieName: string
  version: string
  init: Function
  generateCookie: Function
  trackEvent: Function
  getParamsFromUrl: Function
  eventTracking?: MarxyTrackingFunctions
}

export type MarxyTrackingFunctions = {
  trackCartUpdate: Function
}

export type MarxyType = {
  apiUrl?: string
  exponeaId: string
  marxySpaEnabled: boolean
}

export enum MarxyEvents {
  CART_UPDATE = 'cart_update',
  PAGE_VISIT = 'page_visit',
  SESSION_PING = 'session_ping',
  VIEW_ITEM = 'view_item',
  VIEW_CATEGORY = 'view_category',
}

export interface Exponea {
  initialize: Function
}

export interface ExponeaLoader {
  init?: Function
}

export interface MarxyProperties {
  account_type?: string
  action: string
  brand: string
  browser?: string
  category_id: string
  category_name: string
  device?: string
  location?: string
  os?: string
  path?: string
  personalization?: string
  product_id: string
  quantity: number
  referrer?: null
  total_price: number
  total_quantity: number
  variant_id: string
  variant_list: Array<any>
  update?: any
  category_title?: string
  categories_list?: Array<String>
}

export interface MarxyCategoryData {
  categoriesList: string[]
  categoryId: string
  categoryTitle: string
  categoryUrl: string
}
